import { useSpaceDetail } from '@confluence/space-utils/entry-points/useSpaceDetail';

import { useCreateSpaceExperiment } from './CreateSpaceDrawer/useCreateSpaceExperiment';

export const useSpaceType = ({ spaceKey }) => {
	const { isSpaceTypesCreationFlowEnabled } = useCreateSpaceExperiment();
	const { data: spaceData } = useSpaceDetail(spaceKey);

	const isKnowledgeBaseSpace =
		spaceData?.type === 'knowledge_base' && isSpaceTypesCreationFlowEnabled;

	return { spaceType: spaceData?.type, isKnowledgeBaseSpace };
};
